import { configureStore } from '@reduxjs/toolkit';
import tagsReducer from '@/store/slices/tagsSlice';
import workflowsReducer from '@/store/slices/workflowsSlice';
import documentInstancesReducer from '@/store/slices/documentInstancesSlice';

export const store = configureStore({
  reducer: {
    tags: tagsReducer,
    workflows: workflowsReducer,
    documentInstances: documentInstancesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
